howspace.aiCreditUsage = (() => {
    'use strict';

    // Draws the monthly AI credit usage chart inside the "AI credit usage" modal. Used as the
    // ModalSettings init callback so it can be shared by any app that renders the ai-team credits
    // card via AdminSharedPartial/CustomerSharedPartial (admin, customer account manager, ...).
    const init = modal => {
        modal = $(modal);

        const canvas = modal.find('.ai-team-usage-modal-canvas')[0];
        if (!canvas) {
            return;
        }

        let monthlyUsage = [];
        try {
            monthlyUsage = JSON.parse(canvas.getAttribute('data-monthly-usage') || '[]');
        } catch {
            monthlyUsage = [];
        }

        howspace.chart.init(() => {
            const existingChart = Chart.getChart(canvas);
            if (existingChart) {
                existingChart.destroy();
            }

            const labels = monthlyUsage.map(month => month.label);
            const data = monthlyUsage.map(month => month.credits);
            const barColor = getComputedStyle(document.documentElement)
                .getPropertyValue('--howspace-color-violet-50').trim() || '#c4b5fd';
            const lineColor = getComputedStyle(document.documentElement)
                .getPropertyValue('--howspace-color-black-100').trim() || '#000';

            const chart = new Chart(canvas.getContext('2d'), {
                data: {
                    labels,
                    datasets: [
                        {
                            type: 'bar',
                            label: 'Credits used',
                            data,
                            backgroundColor: barColor,
                            borderRadius: 4,
                            order: 2
                        },
                        {
                            type: 'line',
                            label: 'Credits used',
                            data,
                            borderColor: lineColor,
                            borderWidth: 2,
                            pointRadius: 0,
                            tension: 0,
                            fill: false,
                            order: 1
                        }
                    ]
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            callbacks: {
                                label: context => context.parsed.y.toLocaleString() + ' credits'
                            }
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                callback: value => value.toLocaleString()
                            }
                        }
                    }
                }
            });

            modal.one(howspace.components.modal.MODAL_CLOSED, () => {
                chart.destroy();
            });
        });
    };

    return {
        init
    };
})();
